import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { skipWhile, take } from 'rxjs/operators';

import * as actions from '../store/delivery.actions';

@Injectable()
export class DeliveryOverviewResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    this.store
      .select(UserSelectors.selectLocations)
      .pipe(
        skipWhile((userLocations) => userLocations === undefined || userLocations === null),
        take(1),
      )
      .subscribe((userLocations) => {
        this.store.dispatch(
          actions.loadData({
            locationIds: userLocations
              .filter((location) => location.isSelected)
              .map((location) => location.id),
          }),
        );
      });
    return of(true);
  }
}
